export function isTickerApiLimitResponse(data, status) {
  return status === 429 || data?.code === "ticker_api_weekly_limit";
}

export function formatTickerApiLimitMessage(data) {
  const usage = data?.ticker_api_usage;
  const limit = usage?.limit ?? 5;
  const used = usage?.used ?? limit;
  const remaining = usage?.remaining ?? 0;

  let resetLine = "";
  if (usage?.resets_at) {
    try {
      const resetDate = new Date(usage.resets_at);
      resetLine = ` Limit resets ${resetDate.toLocaleString(undefined, {
        weekday: "short",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
      })}.`;
    } catch {
      /* ignore */
    }
  }

  const headline =
    data?.message ||
    `You have used all ${limit} free ticker lookups for this week.`;

  return {
    headline,
    detail: `Used ${used} of ${limit} this week (${remaining} remaining).${resetLine}`,
    fullText: `${headline} Used ${used} of ${limit} this week.${resetLine}`,
  };
}
